import React from "react";
import styles from "../../../styles/forms/SharedForm.module.css";
import { ArrowLeftIcon, SendIcon } from "./FormIcons";
import { useFormContext } from "./FormContext";
import T, { useTranslate } from "../../T";

export function FormSection({ id, title, children }) {
  return (
    <div id={id} className={styles.formSectionCard}>
      <div className={styles.formSectionHeader}><T>{title}</T></div>
      {children}
    </div>
  );
}

export function FormField({ label, name, required, children, style }) {
  const context = useFormContext();
  const { tText } = useTranslate();
  let hasError = false;
  let errorMessage = "";

  if (context) {
    const { formData, touched, handleBlur } = context;
    const isTouched = touched[name];
    const value = formData[name];
    
    if (isTouched && required && (!value || value.toString().trim() === '')) {
      hasError = true;
      errorMessage = tText("This field is required");
    }

    children = React.Children.map(children, (child) => {
      if (React.isValidElement(child)) {
        return React.cloneElement(child, {
          onBlur: (e) => {
            if (child.props.onBlur) child.props.onBlur(e);
            handleBlur(e);
          }
        });
      }
      return child;
    });
  }

  return (
    <div className={`${styles.field} ${hasError ? styles.hasError : ''}`} style={style}>
      <label className={styles.label} htmlFor={name}>
        <T>{label}</T> {required && <span className={styles.required}>*</span>}
      </label>
      {hasError && <div className={styles.errorMessage}>{errorMessage}</div>}
      {children}
    </div>
  );
}

export function PinnedSubmit({ isSubmitting, isValid, onSubmit, onInvalidSubmit, label = "Submit Request", note = "Your submission is secure and goes directly to the Tech Support Team." }) {
  return (
    <div className={styles.pinnedSubmitWrapper}>
      <div className={styles.securityNote}>
        <div className={styles.securityIcon}>
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
            <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
          </svg>
        </div>
        <T>{note}</T>
      </div>
      <div 
        style={{ display: 'inline-block' }}
        onClick={() => {
          if (!isValid && onInvalidSubmit) {
            onInvalidSubmit();
          }
        }}
      >
        <button
          type="button"
          className={styles.submitBtn}
          onClick={isValid && !isSubmitting ? onSubmit : undefined}
          disabled={isSubmitting || !isValid}
          style={{ flex: "0 0 auto", padding: "14px 32px", pointerEvents: (!isValid || isSubmitting) ? 'none' : 'auto' }}
        >
          {isSubmitting ? (
            <span><T>Submitting…</T></span>
          ) : (
            <>
              <span><T>{label}</T></span>
              <SendIcon />
            </>
          )}
        </button>
      </div>
    </div>
  );
}

export function SuccessCard({ title = "Request Submitted", description, onBack, backLabel = "Back to Help Center" }) {
  return (
    <div className={styles.successCard}>
      <div className={styles.successIcon}>✓</div>
      <h2 className={styles.successTitle}><T>{title}</T></h2>
      <p className={styles.successDesc}><T>{description}</T></p>
      <button type="button" className={styles.backBtn} onClick={onBack}>
        <ArrowLeftIcon /> <T>{backLabel}</T>
      </button>
    </div>
  );
}
